import { Link } from "react-router-dom";
import { buttonStyles } from "@/components/ui/Button";
import { EmptyState } from "@/components/ui/EmptyState";

export function NotFoundPage() {
  return (
    <EmptyState
      title="A trilha termina aqui"
      description="A rota solicitada não existe nesta versão da aplicação. Volte para a home ou abra o dashboard para continuar."
      action={
        <Link to="/" className={buttonStyles()}>
          Retornar para home
        </Link>
      }
    />
  );
}
